
<div class="modal-signup modal-content" >
  <div>
    <form class="form " novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


        <div class="card-header wh-header padding-bottom-0px padding-right-5px padding-left-10px">
          <div class="row">
            <div class="col-md-4 padding-right-0px">
              Edit
            </div>
            <div class="col-md-7 padding-right-0px">
              <button type="submit" class="btn font-size-13px actions-btn-prime float-right">Save</button>
            </div>
            <div class="col-md-1">
              <button type="button" class="close margin-right-10px" data-dismiss="modal"
                      (click)="activeModal.dismiss('Cross click')"
                      aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>




        </div>

        <div class="modal-body padding-top-0px">
          <div class="row border-top-1px border-bottom-1px">
            <div class="col-md-4  text-align-left border-right-1px">

              <div><label class="margin-bottom-0px font-size-14">Date: {{Date| date:'MMM-dd-yyyy'}}</label></div>
            </div>
            <div class="col-md-4  text-align-left border-right-1px">

              <div><label class="margin-bottom-0px font-size-14">Cycle Number : {{Cyclenumber}}</label></div>
            </div>
            <div class="col-md-4 text-align-left border-right-1px">

              <div><label class="margin-bottom-0px font-size-14">DOC : {{DOC}}</label></div>
            </div>
          </div>


          <div class="row my-profile-form margin-top-10">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 text-align-right">
                  <label for="firstName" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Embryo Count </label>
                </div>:
                <div class="col-md-3">

               
                  <label>{{Embryocount}}</label>

                </div>

              </div>

            </div>
          </div>

          <div class="row my-profile-form">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 text-align-right">
                  <label for="firstName" class="label-size margin-bottom-0px margin-top-5px" *ngIf="DOC==2 || DOC==3 || DOC==4 "> Cell Stage </label>
                  <label for="firstName" class="label-size margin-bottom-0px margin-top-5px" *ngIf="DOC==5 || DOC==6 "> Stage </label>
                </div>
                <div class="col-md-3">

                  <CodeTypeValue CodeType="IVFCS" id="CurrentEditEmbryoStoreInfoRequest.CellStage"
                                 [(ngModel)]="CurrentEditEmbryoStoreInfoRequest.CellStage" SelectedValue="CurrentEditEmbryoStoreInfoRequest.CellStage"
                                 name="CurrentEditEmbryoStoreInfoRequest.CellStage" required>

                  </CodeTypeValue>

                </div>

              </div>

            </div>
          </div>

          <div class="row my-profile-form">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 text-align-right">
                  <label for="firstName" class="label-size margin-bottom-0px margin-top-3px"> Grade </label>
                </div>:
                <div class="col-md-3">

                  <label>{{Grade1}}{{Grade2}}</label>


                </div>

              </div>

            </div>
          </div>

          <div class="row my-profile-form">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 text-align-right">
                  <label for="firstName" class="label-size margin-bottom-0px margin-top-3px"> ReGrade </label>
                </div>
                <div class="col-md-3">
                
                  <CodeTypeValue CodeType="D{{DOC}}GR1" id="CurrentEditEmbryoStoreInfoRequest.ReGrade"
                                 [(ngModel)]="CurrentEditEmbryoStoreInfoRequest.ReGrade" SelectedValue="CurrentEditEmbryoStoreInfoRequest.ReGrade"
                                 name="CurrentEditEmbryoStoreInfoRequest.ReGrade" required>

                  </CodeTypeValue>

                </div>
                <div class="col-md-3" *ngIf="DOC>4">
                  <CodeTypeValue CodeType="D{{DOC}}GR2"id="CurrentEditEmbryoStoreInfoRequest.ReGrade2"
                                 [(ngModel)]="CurrentEditEmbryoStoreInfoRequest.ReGrade2" SelectedValue="CurrentEditEmbryoStoreInfoRequest.ReGrade2"
                                 name="CurrentEditEmbryoStoreInfoRequest.ReGrade2"
                                 ></CodeTypeValue>

                </div>

              </div>

            </div>
          </div>
          <div class="row my-profile-form">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 text-align-right">
                  <label for="firstName" class="label-size margin-bottom-0px margin-top-3px">Transfer Count </label>
                </div>
                <div class="col-md-3">
                 
                  <input type="number" class="form-control" placeholder="Transfer Count"
                         id="CurrentEditEmbryoStoreInfoRequest.Count"
                         [(ngModel)]="CurrentEditEmbryoStoreInfoRequest.Count" required
                         name="CurrentEditEmbryoStoreInfoRequest.Count" pattern="^[\sa-zA-Z0-9,._\-?]*$" #RecommendedPackage="ngModel"
                         maxlength="100" />
                 

                </div>
            

              </div>

            </div>
          </div>
          <div class="row my-profile-form">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 text-align-right">
                  <label for="firstName" class="label-size margin-bottom-0px margin-top-3px"> Remarks </label>
                </div>
                <div class="col-md-3">
                  <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Concerns"
                            name="CurrentEditEmbryoStoreInfoRequest.Remarks"
                            [(ngModel)]="CurrentEditEmbryoStoreInfoRequest.Remarks" required minlength="1" maxlength="100"
                            #addconcerns_text="ngModel"></textarea>
                  <small class="form-text text-danger"
                         *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>

                </div>


              </div>

            </div>
          </div>


        </div>
      
      </div>
    </form>
  </div>
</div>
